import countriesCode from "../../lib/utils/countriesCode";
import { getBlackbaudScript, blackbaudOpenPaymentForm } from "./blackbaud";

export function handleBbmsPaymentProcessNextPage() {
  this.isValidForCreateAbandonForm = false;
  const bbmsInfo = {
    bbmsPublicKey: this.bbmsPublicKey,
    bbmsAppId: this.bbmsAppId,
  };

  const transactionData = mapBbmsTransactionData(this.props, bbmsInfo);

  blackbaudOpenPaymentForm(transactionData);
}

export function addBbmsEventListeners() {
  document.addEventListener("checkoutComplete", this.bbmsCheckoutComplete);
}

export function fetchBbmsScript() {
  const script = getBlackbaudScript();

  document.body.appendChild(script);
}

export function mapBbmsTransactionData(props, bbmsInfo) {
  const {
    totalAmount,
    user,
    email,
    first_name,
    last_name,
    city,
    region,
    zip,
    country,
    address,
    cell_phone,
    feeAmount,
  } = props;

  const emailParam = user ? user.get("email") : email;
  const countryCode = countriesCode.filter((countryCode) => countryCode.name === country);

  const totalAmountFloat = parseFloat(totalAmount);
  return {
    key: bbmsInfo.bbmsPublicKey,
    merchant_account_id: bbmsInfo.bbmsAppId,
    is_email_required: true,
    billing_address_email: emailParam,
    billing_address_phone: cell_phone,
    billing_address_first_name: first_name,
    billing_address_last_name: last_name,
    billing_address_city: city,
    billing_address_state: region,
    billing_address_post_code: zip,
    billing_address_country: countryCode && countryCode[0] ? countryCode[0].code : "",
    billing_address_line: address,
    use_apple_pay_donate_button: true,
    amount: totalAmountFloat + (isNaN(feeAmount) ? 0 : feeAmount),
  };
}
